import React, {useState} from 'react';
import Header from '../../components/Header';
import SubHeader from '../../components/subheader';
import { useDispatch, useSelector } from 'react-redux';
import { hasPermission } from '../../components/Permissions';

const Home = () => {
    const [showProposal, setShowProposal]= useState(false)
    const [proposalNumber, setProposalNumber] =useState()
    const [showMenu, setShowMenu] = useState(false)
    const toggleMenu = () => setShowMenu((prev) => !prev)
    const { proposalData } = useSelector((state) => ({
        proposalData: state.proposal.proposalData,
    }));
    const [proposalTab, setProposalTab] = useState(hasPermission("D2C_OFFLINE") ? "D2Cpayment" : hasPermission("BLUE_CHIP_USER") ? "blueChip" : hasPermission("UPFRONT_USER") ? "upfrontPayment" : "Dashboard")
    const user = useSelector((state) => state.authentication)
    const showProposalFunc =(val, data)=>{
        setShowProposal(val)
        setProposalNumber(data)
    }
    return (
        <>
            <Header 
            proposalTab={proposalTab}
            setProposalTab={setProposalTab}
            showProposalFunc={showProposalFunc}
            showMenu={showMenu}
            toggleMenu={toggleMenu} />
            <SubHeader 
            proposalTab={proposalTab}
            setProposalTab={setProposalTab}
            showProposal={showProposal} 
            proposalData={proposalData} 
            proposalNumber={proposalNumber}
            showMenu={showMenu} />
        </>
    )
}

export default Home
